<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: CZK
 * @Date: 2026-07-01 10:27:24
 * @LastEditors: CZK
 * @LastEditTime: 2026-07-01 10:30:56
-->
<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'App'
}
</script>

<style>
/* App level styles (if any) */
#app{min-height:100vh}
</style>